module.exports = __webpack_public_path__ + "img/sea-3.cdd5aae5.jpg";